(function (_) {
    'use strict';

    _['PRODUCTS.CATALOG.TOCART.PRECONFIRM'] = 'Añadir';
    _['PRODUCTS.CATALOG.TOCART.CONFIRM'] = 'Añadir';
    _['PRODUCTS.PRODUCT.TOCART.CONFIRM'] = 'Añadir a cesta';
    _['PRODUCTS.CATEGORY'] = 'Categoría';
    _['PRODUCTS.PRICE'] = 'Precio';
    _['PRODUCTS.TAGS'] = 'Etiquetas';
    _['PRODUCTS.FEATURES'] = 'Cuidados';
    _['PRODUCTS.BRAND'] = 'Marca';

    _['PRODUCTS.FILTERS'] = 'Filtros';
    _['PRODUCTS.FILTERS.FILTER'] = 'Filtrar';
    _['PRODUCTS.FILTERS.DELETE'] = 'Quitar filtros';
    _['PRODUCTS.FILTERS.NAME.LABEL'] = 'Nombre';
    _['PRODUCTS.FILTERS.NAME.PLACEHOLDER'] = 'Buscar por palabras...';
    _['PRODUCTS.FILTERS.CATEGORY.LABEL'] = 'Categoría';
    _['PRODUCTS.FILTERS.CATEGORY.DEFAULT'] = 'Buscar por categoría...';
    _['PRODUCTS.FILTERS.SUBCATEGORY.LABEL'] = 'Subcategoría';
    _['PRODUCTS.FILTERS.SUBCATEGORY.DEFAULT'] = 'Buscar por subcategoría...';
    _['PRODUCTS.FILTERS.PRICE.LABEL'] = 'Ordenar por';
    _['PRODUCTS.FILTERS.PRICE.DEFAULT'] = 'Ordenar por...';
    _['PRODUCTS.FILTERS.PRICE.ASC'] = 'Precio de menor a mayor';
    _['PRODUCTS.FILTERS.PRICE.DESC'] = 'Precio de mayor a menor';

    _['PRODUCTS.PRODUCT.SIZE'] = 'Tamaño';
    _['PRODUCTS.PRODUCT.COLOR'] = 'Color';
    _['PRODUCTS.PRODUCT.NOSTOCK'] = '¡Fuera de stock!';
    _['PRODUCTS.PRODUCT.NOSTOCKATORDER'] = '¡Vaya! Acabas de superar el stock máximo permitido de este producto.';
    _['PRODUCTS.PRODUCT.TOOMUCHAMOUNT'] = '¡Demasiado!';
    _['PRODUCTS.PRODUCT.AMOUNT'] = 'Cantidad';

}(translations['es']));




// WEBPACK FOOTER //
// ./src/app/plugins/products/lang/products-lang_es.js